import { default as loglevel, Logger, LogLevelDesc } from "loglevel";

const logContext = import.meta.env.VITE_TITLE as string;
const logLevel = import.meta.env.VITE_LEVEL_LOG as LogLevelDesc;

let log: Logger;

const initializeLogger = (): Logger => {
	log = loglevel.getLogger(logContext);
	log.setLevel(logLevel);
	return log;
};

export const getLogger = (): Logger => (log ? log : initializeLogger());
